import { Link, useNavigate } from "react-router-dom";
import { useAuth, dashboardPath } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
export function Logo({ dark = false }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-home-link">
      <span className={`flex h-10 w-12 shrink-0 items-center justify-center ${dark ? "rounded-md bg-white px-1.5" : ""}`}>
        <img src="/brand/logo-mark.webp" alt="" className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-105" />
      </span>
      <img src={dark ? "/brand/logo-word-white.webp" : "/brand/logo-word.webp"} alt="Pro Core Digital" className="hidden h-5 w-auto min-[400px]:block sm:h-6" data-testid="logo-wordmark" />
    </Link>
  );
}

export default function Navbar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else navigate(`/#${id}`);
  };

  return (
    <header className="glass-nav sticky top-0 z-50 border-b border-border">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          <button onClick={() => scrollTo("productos")} className="text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-foreground" data-testid="nav-productos">Productos</button>
          <button onClick={() => scrollTo("precios")} className="text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-foreground" data-testid="nav-precios">Precios</button>
          <button onClick={() => scrollTo("distribuidores")} className="text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-foreground" data-testid="nav-distribuidores">Distribuidores</button>
          <button onClick={() => scrollTo("autorizados")} className="text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-foreground" data-testid="nav-autorizados">Autorizados</button>
          <button onClick={() => scrollTo("timbres")} className="text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-foreground" data-testid="nav-timbres">Timbres</button>
          <button onClick={() => scrollTo("ya-compraste")} className="text-sm font-medium text-muted-foreground transition-colors duration-200 hover:text-foreground" data-testid="nav-ya-compraste">Ya compré</button>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <Button onClick={() => navigate(dashboardPath(user.role))} className="rounded-full" data-testid="nav-panel-btn">
              Mi panel
            </Button>
          ) : (
            <>
              <Button variant="ghost" onClick={() => navigate("/login")} className="rounded-full px-3 sm:px-4" data-testid="nav-login-btn">
                Iniciar sesión
              </Button>
              <Button onClick={() => scrollTo("precios")} className="rounded-full" data-testid="nav-comprar-btn">
                Comprar
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
